import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Work Order Management",
        description: "Create, manage, and track service work orders seamlessly, ensuring all tasks are completed on time.",
        imgUrl: "./img/services/field-service/work-order-management.png",
    },
    {
        title: "Resource Scheduling",
        description: "Optimize field resource allocation and scheduling with intelligent scheduling tools.",
        imgUrl: "./img/services/field-service/resouce-scheduling.jpg",
    },
    {
        title: "Mobile App for Technicians",
        description: "Enable technicians with a mobile app to access work orders, client data, and update status in real time.",
        imgUrl: "./img/services/field-service/mobile-app-for-technicans.jpg",
    },
    {
        title: "Asset Management",
        description: "Track and manage assets efficiently, ensuring service technicians have the right equipment and parts.",
        imgUrl: "./img/services/field-service/asset-mangement.jpg",
    },
    {
        title: "Customer Communication",
        description: "Enhance customer satisfaction by providing real-time updates and notifications on service progress.",
        imgUrl: "./img/services/field-service/customer-communication.jpg",
    },
    {
        title: "Analytics & Reporting",
        description: "Utilize advanced analytics to track performance, optimize service operations, and identify areas for improvement.",
        imgUrl: "./img/services/field-service/analytics-and-reporting.jpg",
    },
];

const FieldService = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Field Service", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Field Service Solutions" description="Optimize your field service operations with Dynamics 365 Field Service, delivering real-time, seamless service management for improved customer satisfaction." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is Dynamics 365 Field Service?</h2>
                            <p>
                                Dynamics 365 Field Service helps businesses manage and deliver high-quality field service experiences. It combines intelligent scheduling, work order management, real-time communication, and mobile support for service technicians to ensure efficient operations and increased customer satisfaction.
                            </p>
                            <img
                                src="./img/services/field-service.jpg"
                                alt="Field Service Solutions"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Key Features of Field Service</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Using Dynamics 365 Field Service</h2>
                            <ul>
                                <li>
                                    <strong>Improved Operational Efficiency:</strong> Automate scheduling, dispatching, and reporting to streamline operations and reduce manual effort.
                                </li>
                                <li>
                                    <strong>Enhanced Customer Satisfaction:</strong> Provide real-time updates and proactive communication to customers for a more personalized experience.
                                </li>
                                <li>
                                    <strong>Mobile Empowerment:</strong> Equip field technicians with mobile access to work orders, customer data, and service updates, increasing productivity.
                                </li>
                                <li>
                                    <strong>Real-Time Insights:</strong> Gain actionable insights through analytics and dashboards to optimize field operations and improve decision-making.
                                </li>
                                <li>
                                    <strong>Cost Reduction:</strong> Minimize operational costs by optimizing resource allocation and reducing unnecessary service visits.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Enhance Your Field Service Operations Today</h2>
                            <p>
                                Discover how Dynamics 365 Field Service can transform your field service management. <br />
                                Contact us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default FieldService;
